var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"seasidetms_header_repair_link",attrs:{"to":`${_vm.$store.state.lang ? `/${_vm.$store.state.lang}` : ''}/service`}},[_c('span',{staticClass:"seasidetms_header_repair_link__icon seasidetms-icon-custom-settings"})])
}
var staticRenderFns = []

export { render, staticRenderFns }